import { DhlValidationMessage as NewValidationMessage } from "@dhl-official/react-library";
import React from "react";
import PropTypes from "prop-types";
/**
 * Migration wrapper for ValidationMessage component
 */
export const ValidationMessage = (props) => {
  const { message, variant, ...rest } = props;

  return <NewValidationMessage {...rest} message={message} variant={variant} />;
};

// Maintain static properties for backward compatibility
ValidationMessage.VALID = "valid";
ValidationMessage.INVALID = "invalid";
ValidationMessage.WARNING = "warning";
ValidationMessage.INFO = "info";

ValidationMessage.propTypes = {
  message: PropTypes.string.isRequired,
  variant: PropTypes.string.isRequired,
};

export default ValidationMessage;
